import './header.scss';

import type { MenuProps } from 'antd';
import { Dropdown, Space } from 'antd';
import { useTranslation } from 'react-i18next';

import UserIcon from '@/media/icons/user.svg?react';
import imanLogo from '@/media/iman-logo.svg';
import techDriveLogo from '@/media/tech-drive-logo.png';
import { ROUTES } from '@/shared/constants';
import { LanguageSwitcher } from '@/shared/entities';
import useAppNavigate from '@/shared/hooks/useAppNavigation';
import { removeClientToken } from '@/shared/services/user-hash';
import { Button } from '@/shared/ui';
import { setAuthModalOpen, setIsAuth } from '@/store/auth.slice';
import { useAppDispatch, useAppSelector } from '@/store/store';

const Header: React.FC = () => {
  const { t } = useTranslation();
  const { navigate } = useAppNavigate();
  const dispatch = useAppDispatch();
  const { isUserAuth } = useAppSelector((state) => state.auth);
  const { dealerGroup } = useAppSelector((state) => state.app);
  const isLeasing = useAppSelector(
    (state) => state.app.productType === 'leasing'
  );

  const items: MenuProps['items'] = [
    {
      key: 'applications',
      label: t('my_applications')
    },
    {
      key: 'logout',
      label: t('logout')
    }
  ];

  const onClickItems: MenuProps['onClick'] = ({ key }) => {
    if (key === 'applications') {
      navigate(ROUTES.myOrders);
    } else if (key === 'logout') {
      removeClientToken();
      dispatch(setIsAuth(false));
      navigate(ROUTES.create);
    }
  };

  return (
    <header className="header">
      <div className="header__container">
        <div className="header__logo">
          {isLeasing ? (
            <img src={imanLogo} alt="Iman" />
          ) : dealerGroup?.logo_url ? (
            <img src={dealerGroup.logo_url} alt={dealerGroup.name} />
          ) : (
            <img src={techDriveLogo} alt="Tech Drive" />
          )}
        </div>

        <div className="header__actions">
          <LanguageSwitcher className="header__language-switcher" />
          {isUserAuth ? (
            <Dropdown
              menu={{ items, onClick: onClickItems }}
              placement="bottomRight"
              className="header__user-button"
              arrow
            >
              <Space className="header__user">
                <UserIcon />
              </Space>
            </Dropdown>
          ) : (
            !isLeasing && (
              <Button
                variant="filled-blue"
                onClick={() => dispatch(setAuthModalOpen(true))}
                className="header__login-button"
                size="small"
              >
                {t('login')}
              </Button>
            )
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
